import '../common';

import {createApp} from 'vue';
import {Toast} from 'vant';
import {sentryInit} from '@/utils/sentry';
import http from '../../utils/http';
import api from '../../api/index';
import App from './App.vue';
import router from './router';

const app = createApp(App);
sentryInit(app, router);

// 将$http挂载到vue的原型上
app.config.globalProperties.$http = http;
app.config.globalProperties.$Api = api;

app.use(router).use(Toast);
app.mount('#app');
